import {EncryptStorage} from 'encrypt-storage';
import {hashSHA512} from './Utils';

/**
 * hash sha-512 ict-12345
 *
 */

let REACT_APP_STORAGE_KEY = hashSHA512();

export const encryptStorage = new EncryptStorage(REACT_APP_STORAGE_KEY, {
  prefix: '@ict-storage',
});
